import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-poker-2",
  "use": "icon-si-glyph-poker-2-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-poker-2\" id=\"icon-si-glyph-poker-2\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>620</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M10.494,1.01 L4.412,1.01 C3.082,1.01 2,1.107 2,2.454 L2,15.555 C2,16.903 3.082,17 4.412,17 L10.494,17 C11.824,17 12.906,16.902 12.906,15.555 L12.906,2.454 C12.906,1.106 11.824,1.01 10.494,1.01 L10.494,1.01 Z M7.489,13.135 L4.748,9.041 L7.572,4.926 L10.314,9.019 L7.489,13.135 L7.489,13.135 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-poker-2.svg
// module id = vKHc
// module chunks = 62